import saPlay from '@/helpers/saPlay';
import gtagEvent from '@/helpers/gtagEvent';

export default function (wordCard: Element) {
  if (wordCard.hasAttribute('data-correct')) {
    if (wordCard.getAttribute('data-correct') === 'true') {
      wordCard.addEventListener('click', () => {
        const audioEl = document.querySelector('#correct-audio') as HTMLAudioElement;
        if (audioEl) saPlay(audioEl);
        gtagEvent('vote_sfx_card', {
          text: (wordCard as HTMLElement).innerText,
          correct: 'true',
        });
      });
    } else {
      wordCard.addEventListener('click', () => {
        const audioEl = document.querySelector('#incorrect-audio') as HTMLAudioElement;
        if (audioEl) saPlay(audioEl);
        gtagEvent('vote_sfx_card', {
          text: (wordCard as HTMLElement).innerText,
          correct: 'false',
        });
      });
    }
  }
}
